// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eeb8041a","239":"a979d319","455":"64a094c9"}[chunkId] + ".chunk.js";
};